import React, { Component } from 'react';
import { trackEvent } from '../../utils/analytics';
class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, error: null };
        this.handleReset = () => {
            this.setState({ hasError: false, error: null });
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info.componentStack);
        trackEvent('render_crash', 'error', error.message);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (React.createElement("div", { className: "container", style: { marginTop: '60px', textAlign: 'center' } },
                React.createElement("div", { className: "panel panel-danger" },
                    React.createElement("div", { className: "panel-heading" },
                        React.createElement("h3", { className: "panel-title" },
                            React.createElement("i", { className: "fa fa-exclamation-triangle" }),
                            " Something went wrong")),
                    React.createElement("div", { className: "panel-body" },
                        React.createElement("p", null, "An unexpected error occurred. Please try again."),
                        this.state.error && (React.createElement("pre", { style: { textAlign: 'left', fontSize: '12px', maxHeight: '150px', overflow: 'auto' } }, this.state.error.message)),
                        React.createElement("button", { className: "btn btn-primary", onClick: this.handleReset, style: { marginTop: '10px' } },
                            React.createElement("i", { className: "fa fa-refresh" }),
                            " Try Again"),
                        React.createElement("a", { href: "/", className: "btn btn-default", style: { marginTop: '10px', marginLeft: '10px' } },
                            React.createElement("i", { className: "fa fa-home" }),
                            " Go Home")))));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
